class GetArticleCategoriesUseCase {
    /**
     * @param {ArticleRepository} articleRepository
     */
    constructor(articleRepository) {
        this.articleRepository = articleRepository;
    }

    /**
     * Retrieves a list of article categories.
     * @returns {Promise<string[]>}
     */
    async execute() {
        return this.articleRepository.getArticleCategories();
    }
}

export default GetArticleCategoriesUseCase;
